<template>
    <div class="listingViewCard">
        <div :class="{'photoContainerGrayHidden': !isLoading, 'photoContainerGray': isLoading}"></div>
        <div :class="{'photoContainer': true, 'photoContainerSmall': isTitleTwoRows}">
            <router-link :to="{ path: `/${$route.params.locale || 'et'}/kuulutus/${listingData.idListing}` }">
                <img 
                    class="productImage"
                    @click="openListing()"
                    height="280px" 
                    width="100%" 
                    v-if="thumbnailName"
                    :src="$fetchIp+'/static/images/listings/'+thumbnailName" 
                    alt=""
                    >
            </router-link>
        </div>
        <div style="margin-top: -10px;">
            <div class="titleContainer" v-if="!isLoading">
                <router-link :to="{ path: `/${$route.params.locale || 'et'}/kuulutus/${listingData.idListing}` }"><h2 ref="titleElement">{{listingData.title}}</h2></router-link>
            </div>
            <div class="shopNameContainer">
                <p>{{listingData.listingTag.translations.et}}</p>
            </div>
            <div class="price">
                <p>€ {{ listingData.price.toFixed(2) }}</p>
                <Button @click="addToOrderWorkaround" label="" size="small" style="width: 30px; height: 30px; margin-top: -6px; background: steelblue; color: white" icon="pi pi-plus" text rounded />
            </div>
        </div>
    </div>
</template>

<script>
import addToOrder from '@/apiFetches(old)/addListingToOrder'
import 'primeicons/primeicons.css';
import Button from 'primevue/button'

export default {
    name: 'productCard',
    components: {
        Button
    },
    props: {
        listingData: {
            required: true
        },
        waitTime: {
            default: 1000
        },
        skeletonOnly: null,
        shopPage: {},
        index: {},
        currentLang: {default: "et"}
    },
    watch: {
        listingData: function() {
            this.coverImg()
        },
        skeletonOnly() {
            this.isLoading = this.skeletonOnly
        }
    },
    computed: {
        isTitleTwoRows() {
            return this.titleHeight > 43; // Adjust this threshold if needed
        }
    },
    data() {
        return {
            errors: '',
            quantity: 1,
            error: false,
            notifArea: false,
            loaderActive: false,
            mobileActive: false,
            loadedAmount: 0,

            isLoading: true,
            thumbnailName: '',
            shopThumbnailName: '',
            titleHeight: 0,
        } 
    },  
    methods: { 
        clickAway() {
            this.mobileActive = false
        },

        coverImg() {
            this.isLoading = true;
            const waitTimeRaw = this.index * 50 + this.waitTime;

            if (process.env.NODE_ENV === "production") {
                const name = this.listingData.coverImg;
                const nameShop = this.listingData.shopCoverImg;
                const newName = name.split('.');
                const newNameShop = nameShop.split('.');
                this.thumbnailName = `${newName[0]}.thumb.${newName[1]}`;
                this.shopThumbnailName = `${newNameShop[0]}.thumb.${newNameShop[1]}`;
            } else {
                this.thumbnailName = this.listingData.coverImg;
                this.shopThumbnailName = this.listingData.shopCoverImg;
            }

            setTimeout(() => {
                this.isLoading = false;
                this.checkTitleHeight(); // Check title height after loading
            }, waitTimeRaw);
        },

        checkTitleHeight() {
            if (this.$refs.titleElement) {
                this.titleHeight = this.$refs.titleElement.offsetHeight;
            }
        },

        openListing() {
            this.$emit('startLoading')
            const lang = this.$route.params.locale || 'et';
            this.$router.push(`/${lang}/kuulutus/${this.listingData.idListing}`);
        },

        addToOrderWorkaround() {
            this.$emit('logout')
            setTimeout(() => {
                this.addedToOrder = true
                this.successIcon = true
                this.addedToOrderDelyed = true
                this.notifArea = true

                this.addOrderToLocalstorage()
                setTimeout(() => {
                    this.$emit('openCartSidebar')
                }, 500)
                this.$emit("emitMenuReload")
            }, 100);
        },

        addOrderToLocalstorage() {
            const storageData = localStorage.getItem('guestOrder')
            let guestOrders = JSON.parse(storageData)

            if(!Array.isArray(guestOrders)) {
                guestOrders = []
            }

            const listingsData = {
                title: this.listingData.title, 
                img: this.listingData.coverImg,
                price: this.listingData.price, 
                idListing: this.listingData.idListing, 
                qty: this.quantity,
                attr: {dimensions: this.listingData.attr.dimensions, deliveryTime: this.listingData.deliveryTime}
            }

            const shopData = {
                shopName: this.listingData.shopName,
                shopCoverImg: this.listingData.shopCoverImg,
                idShop: this.listingData.idShop,
                listings: [listingsData]
            }

            guestOrders.forEach((e, i) => {
                // function checkIfShopOrderExists
                if(e.idShop == this.listingData.idShop) {
                    const orderListings = guestOrders[i].listings

                    orderListings.forEach((el, index) => {
                        // function appendQtyToExistentListingInOrder
                        if(el.idListing == this.listingData.idListing) {
                            orderListings[index].qty = orderListings[index].qty + this.quantity
                            this.$toast.add({
                                severity: 'warn',
                                summary: this.currentLang === 'et'
                                    ? 'Toode juba on tellimuses, kogust suurendati!'
                                    : 'Product is already in the order, quantity has been increased!',
                                detail: '',
                                life: 5000
                            });
                        }
                    })
                    // function addListingToExistingOrder
                    if(!orderListings.find(e => e.idListing == this.listingData.idListing)) {
                        orderListings.push(listingsData)
                    }
                }
            })
            // function createNewOrder
            if(!guestOrders.find(e => e.idShop == this.listingData.idShop)) {
                guestOrders.push(shopData)
            }

            let string = JSON.stringify(guestOrders)
            localStorage.setItem('guestOrder', string)
        },

        addToOrder(idListing) {
            this.loaderActive = true
            addToOrder(idListing, this.quantity)
            .then((res) => {
                this.loaderActive = false
                const respo = Object.values(res)
                this.response = respo
                if(res.status == 'success') {
                    // this.$track.customEvent('Toode lisatud tellimusse', 'orderProcess', 'addToOrderCount')
                    this.$emit('openCartSidebar')
                }
                if (respo[1] === "Cannot add twice the same listing to the order.") {
                    this.notifArea = false
                    this.error = true
                    this.errors = 'Toode on juba lisatud tellimusse.'
                }
                else if (respo[1] === "Quantity must be more than zero.") {
                    this.notifArea = false
                    this.errors = 'Koguse peab olema suurem kui 0.'
                }
                else if (respo[1] === "Not possible to order from a shop that belongs to the same union that the user is a member of.") {
                    this.notifArea = false
                    this.errors = 'Iseendalt ei ole võimalik tellida'
                }
                else if (respo[1] === "Store is currently not open for orders.") {
                    this.notifArea = false
                    this.errors = 'Pood ei ole tellimustele avatud.'
                }
                else if (res.error === "Not allowed to access.") {
                    this.notifArea = true
                    this.addOrderToLocalstorage()
    
                    this.$emit('openCartSidebar')
                }
                else {
                    this.errors = []
                    this.notifArea = true
                }
            })
            setTimeout(() => {
                this.notifArea = false
                this.errors = ''
                this.error = false
            }, 30);
        },
    },
    
    mounted() {
        this.coverImg();
        this.checkTitleHeight(); // Initial check
    },
    updated() {
        this.checkTitleHeight(); // Recheck after updates
    }
}
</script>

<style scoped>
.listingViewCard {
    position: relative;
    background: white;
    height: 308px;
    width: 238px;
    padding: 5px;
    border-radius: 15px;
    border: 1px solid #eee;
    -webkit-transition: .3s;
    -o-transition: .3s;
    transition: .3s;
}
.listingViewCard:hover {
    -webkit-transition: .3s;
    -o-transition: .3s;
    transition: .3s;
    -webkit-box-shadow: 0 15px 70px rgba(0,0,0,.07);
            box-shadow: 0 15px 70px rgba(0,0,0,.07);
}
.photoContainer {
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 220px;
    margin-left: 0px;
    padding-right: 0px;
    padding-left: 0px;
    padding-top: 0px;
    border-radius: 10px;
    background: white;
    text-align: center;
    cursor: pointer;
    margin: 0 auto;
}
.photoContainerSmall {
    margin-bottom: 7px;
    height: 190px; /* Adjusted height for two-row titles */
}
.photoContainerGray {
    position: absolute;
    overflow: hidden;
    left: 0;
    top: 0;
    height: 308px;
    width: 238px;
    margin-left: 0px;
    border-radius: 15px;
    text-align: center;
    cursor: pointer;
    z-index: 901;
    background: rgb(234,234,234);
    /* transition: .5s; */
}
.photoContainerGrayHidden {
    position: absolute;
    overflow: hidden;
    left: 0;
    top: 0;
    height: 308px;
    width: 238px;
    margin-left: 0px;
    border-radius: 15px;
    text-align: center;
    cursor: pointer;
    z-index: -10;
    background: rgba(234, 234, 234, 0);
    -webkit-transition: .5s;
    -o-transition: .5s;
    transition: .5s;
}
.productImage {
    position: relative;
    overflow: hidden;
    z-index: 10;
    margin-top: -45px;
    -o-object-fit: contain;
       object-fit: contain;
    -webkit-transition: 0.3s all ease-in-out;
    -o-transition: 0.3s all ease-in-out;
    transition: 0.3s all ease-in-out;
    border-radius: 20px;
}

.productImage {
    -webkit-transform: scale(1.0);
        -ms-transform: scale(1.0);
            transform: scale(1.0);
}
.photoContainer:hover .productImage {
    -webkit-transform: scale(1.16);
        -ms-transform: scale(1.16);
            transform: scale(1.16);
    -webkit-transition: 0.3s all ease-in-out;
    -o-transition: 0.3s all ease-in-out;
    transition: 0.3s all ease-in-out;
}
.titleContainer {
    z-index: 99;
    padding-bottom: 0px;
    padding-top: 8px;
    width: 100%;
    word-wrap: break-word;
}
h2 {
    text-align: start;
    margin: 0;
    max-height: 45px;
    margin-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;
    font-size: 1rem;
    color: #22262A;
    overflow: hidden;
    display: -webkit-box !important;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
    font-family: 'Satoshi-Medium';
}
.titleContainer h2:hover {
    color: #64C3A2;
    cursor: pointer;
}
.shopNameContainer {
    opacity: 1;
    margin-top: 2px;
    position: relative;
    z-index: 100;
    color: rgb(160, 160, 160);
    /* -webkit-transition: .3s;
    -o-transition: .3s;
    transition: .3s; */
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}
.shopNameContainer p {
    margin: 0;
    font-size: 14px;
    padding-left: 5px;
    text-align: start;
    cursor: pointer;
    font-family: 'Satoshi-medium';
    
}
.shopNameContainer p {
    color: rgb(200, 200, 200);
}
.shopNameContainer p:hover {
    text-decoration: underline;
}
.price {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    padding-left: 5px;
    padding-right: 5px;
    margin-top: 5px;
}
.price p {
    margin: 0;
    font-size: 18px;
    font-family: 'DM sans', sans-serif;
    color: steelblue;
}
.shopNameContainerGray {
    z-index: 100;
    padding-bottom: 3px;
    padding-top: 8px;
    border-radius: 5px;
    margin-left: 3px;
    margin-top: 8px;
    width: 50%;
    background: rgb(234,234,234);
}
.priceTag {
    z-index: 101;
    padding-left: 13px;
    padding-right: 10px;
    padding-top: 3px;
    padding-bottom: 3px;
    bottom: 0px;
    right: 0px;
    position: absolute;
    background: rgba(41, 41, 41, 0.733);
    border-radius: 10px 0px 0px 0px;
}
.priceTag h3 {
    margin: 0;
    color: white;
    text-align: center;
    font-size: 1.2rem;
    font-family: 'DM sans', sans-serif;
    font-weight: 400;
}
.priceTag a {
    color: white;
}
#addToCardIcon {
    position: absolute;
    bottom: 0px;
    left: 0px;
    z-index: 900;
    font-size: 25px;
    color: rgb(255, 255, 255);
    padding: 10px 20px 9px 11px;
    background: #0D89EC;
    border-radius: 40px 400px 40px 200px;
}

@media (max-width: 430px) {
    .listingViewCard {
        height: 338px;
        width: 100%;
    }
    .photoContainer {
        height: 250px;
    }
    .photoContainerSmall {
        height: 220px; /* Adjusted height for two-row titles */
    }
    .photoContainerGray {
        height: 338px;
        width: 100%;
    }
    .photoContainerGrayHidden {
        height: 338px;
        width: 100%;
    }
}
</style>